import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { ButtonModule, DialogModule, MessageService } from 'primeng';
import { JobsService } from '../../services';
import { AutoDirectService } from '../../services/auto-direct.service';
import { Message } from '../../classes/Message';
import { VmePipesModule } from '../../vme-pipes.module';

@Component({
  selector: 'app-queue-auto-direct-button',
  templateUrl: './queue-auto-direct-button.component.html',
  standalone: true,
  imports: [NgIf, ButtonModule, DialogModule, VmePipesModule],
})
export class QueueAutoDirectButtonComponent implements OnInit {
  @Input() jobIds: number[] = [];
  @Input() buttonClass: string = 'ui-button ui-button-secondary';
  @Input() buttonLabel: string = 'Queue Auto Direct';
  @Input() disabled: boolean = false;

  @Output() queued = new EventEmitter<void>();

  public showDialog: boolean = false;
  public queuing: boolean = false;
  public nextRun: string | null = null;

  constructor(
    private jobsService: JobsService,
    private autoDirectService: AutoDirectService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.autoDirectService.getNextRun().then((x) => (this.nextRun = x));
  }

  public get jobCount(): number {
    return this.jobIds?.length ?? 0;
  }

  public openDialog(): void {
    if (this.disabled || this.jobCount === 0) {
      return;
    }
    this.showDialog = true;
  }

  async confirm(): Promise<void> {
    this.queuing = true;
    try {
      await this.jobsService.queueJobsForAutoDirect(this.jobIds);
      this.queued.emit();
    } catch (err) {
      this.messageService.add(
        Message.Error(
          'An error occurred while queuing the job for Auto Direct. Please try again.',
          'Auto Direct',
        ),
      );
    } finally {
      this.queuing = false;
      this.showDialog = false;
    }
  }
}
